import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AGREEXA_APP_URL } from '../lib/links';
import { Bot, X, Sparkles } from 'lucide-react';
export function FloatingAIAssistant() {
  const [isOpen, setIsOpen] = useState(false);
  return <>
      <AnimatePresence data-id="element-75">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} className="fixed bottom-24 right-6 w-80 sm:w-96 glass-card rounded-2xl shadow-2xl z-50 overflow-hidden border border-white/20" data-id="element-76">
            <div className="p-4 bg-gradient-to-r from-navy-900 to-navy-800 text-white flex justify-between items-center" data-id="element-77">
              <div className="flex items-center gap-2" data-id="element-78">
                <Bot size={20} className="text-orange-400" data-id="element-79" />
                <span className="font-semibold" data-id="element-80">Agreexa AI</span>
              </div>
              <button onClick={() => setIsOpen(false)} className="text-gray-400 hover:text-white transition-colors" data-id="element-81">
                <X size={20} data-id="element-82" />
              </button>
            </div>
            <div className="p-6 h-64 bg-soft dark:bg-navy-900 overflow-y-auto flex flex-col gap-4" data-id="element-83">
              <div className="bg-white dark:bg-navy-800 p-3 rounded-xl rounded-tl-none shadow-sm text-sm text-navy-900 dark:text-gray-200 border border-gray-100 dark:border-navy-700 self-start max-w-[85%]" data-id="element-84">
                Hi! I'm your Maker Assistant. What are we building today? I can
                help with plans, calculations, or troubleshooting.
              </div>
            </div>
            <div className="p-4 bg-white dark:bg-navy-800 border-t border-gray-100 dark:border-navy-700" data-id="element-85">
              <div className="relative" data-id="element-86">
                <input type="text" placeholder="Ask me anything..." className="w-full bg-soft dark:bg-navy-900 border border-gray-200 dark:border-navy-700 rounded-full px-4 py-2 text-sm text-navy-900 dark:text-white focus:outline-none focus:border-orange-500" data-id="element-87" />
                <button onClick={() => {
              window.location.href = AGREEXA_APP_URL;
            }} className="absolute right-2 top-1/2 -translate-y-1/2 text-orange-500 p-1 hover:text-orange-600 transition-colors" data-id="element-88">
                  <Sparkles size={16} data-id="element-89" />
                </button>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>

      <motion.button whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} onClick={() => setIsOpen(!isOpen)} className="fixed bottom-6 right-6 w-14 h-14 rounded-full bg-gradient-to-r from-orange-500 to-orange-600 text-white shadow-xl shadow-orange-500/30 flex items-center justify-center z-50 hover:shadow-orange-500/50 transition-shadow" data-id="element-90">
        {isOpen ? <X size={24} data-id="element-91" /> : <Bot size={28} data-id="element-92" />}
      </motion.button>
    </>;
}